/* ==========================================================================
   WISE V23 — Navigation : header verre (réduction au scroll), barre d'annonce
   tournante, méga-menu ordinateur, tiroir mobile plein écran, recherche plein
   écran, barre d'onglets. Sans dépendance, chargé en defer.
   La recherche prédictive (#search-input / #search-suggest), le tiroir panier
   ([data-drawer-open]) et les badges restent gérés par assets/wise.js.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktopMQ = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };

  /* ---------- Verrou de défilement ---------- */
  var locks = 0;
  function lock() {
    if (locks++ === 0) root.classList.add('v23n-lock');
  }
  function unlock() {
    locks = Math.max(0, locks - 1);
    if (!locks) root.classList.remove('v23n-lock');
  }

  /* ---------- Piège à focus ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';
  function visibleFocusables(container) {
    return $all(FOCUSABLE, container).filter(function (el) {
      if (el.closest('[hidden]')) return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === doc.activeElement;
    });
  }
  function trapTab(e, container) {
    if (e.key !== 'Tab') return;
    var items = visibleFocusables(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (doc.activeElement === first || !container.contains(doc.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (doc.activeElement === last || !container.contains(doc.activeElement))) {
      e.preventDefault(); first.focus();
    }
  }

  /* ---------- Header : état réduit / transparent ----------
     (la hauteur au repos --v23-head-h est fixée en CSS, sans mesure JS) */
  var wrap = $('[data-v23-header]');
  if (wrap) {
    var scrolledState = null;
    var onScroll = function () {
      var y = window.scrollY || window.pageYOffset || 0;
      var s = y > 24;
      if (s !== scrolledState) { scrolledState = s; wrap.classList.toggle('is-scrolled', s); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    root.classList.add('v23n-nav-ready');
  }

  /* ---------- Barre d'annonce : rotation douce ---------- */
  var ann = $('[data-v23-ann]');
  if (ann) {
    var items = $all('.v23n-ann__item', ann);
    if (items.length > 1) {
      var idx = 0;
      var paused = false;
      ann.addEventListener('mouseenter', function () { paused = true; });
      ann.addEventListener('mouseleave', function () { paused = false; });
      ann.addEventListener('focusin', function () { paused = true; });
      ann.addEventListener('focusout', function () { paused = false; });
      setInterval(function () {
        if (paused || doc.hidden) return;
        items[idx].classList.remove('is-on');
        items[idx].classList.add('is-out');
        var prev = items[idx];
        setTimeout(function () { prev.classList.remove('is-out'); }, reduceMotion ? 0 : 520);
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-on');
      }, 4200);
    }
  }

  /* ---------- Méga-menu (ordinateur) ---------- */
  var megaTrigger = $('[data-v23-mega-trigger]');
  var mega = $('[data-v23-mega]');
  var megaRoot = $('[data-v23-mega-root]');
  var scrim = $('[data-v23-mega-scrim]');
  var megaOpenTimer = null;
  var megaCloseTimer = null;
  var megaOpenedAt = 0;
  function megaIsOpen() { return mega && mega.classList.contains('is-open'); }
  function openMega() {
    if (!mega || megaIsOpen()) return;
    clearTimeout(megaCloseTimer);
    megaOpenedAt = Date.now();
    mega.classList.add('is-open');
    if (wrap) wrap.classList.add('is-mega');
    if (scrim) scrim.classList.add('is-on');
    megaTrigger.setAttribute('aria-expanded', 'true');
  }
  function closeMega(returnFocus) {
    clearTimeout(megaOpenTimer);
    if (!mega || !megaIsOpen()) return;
    mega.classList.remove('is-open');
    if (wrap) wrap.classList.remove('is-mega');
    if (scrim) scrim.classList.remove('is-on');
    megaTrigger.setAttribute('aria-expanded', 'false');
    if (returnFocus) megaTrigger.focus();
  }
  if (megaTrigger && mega) {
    megaTrigger.addEventListener('click', function () {
      // Survol puis clic : on ne referme pas un panneau que le survol vient d'ouvrir
      if (megaIsOpen() && Date.now() - megaOpenedAt > 700) closeMega(); else openMega();
    });
    var hoverIn = function () {
      if (!desktopMQ.matches) return;
      clearTimeout(megaCloseTimer);
      if (!megaIsOpen()) megaOpenTimer = setTimeout(openMega, 90);
    };
    var hoverOut = function () {
      if (!desktopMQ.matches) return;
      clearTimeout(megaOpenTimer);
      megaCloseTimer = setTimeout(function () { closeMega(); }, 220);
    };
    [megaRoot, mega].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', hoverIn);
      el.addEventListener('mouseleave', hoverOut);
    });
    megaTrigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' && desktopMQ.matches) {
        e.preventDefault();
        openMega();
        var first = $('a', mega);
        if (first) first.focus();
      }
    });
    mega.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); closeMega(true); }
    });
    // Fermeture quand le focus sort du déclencheur et du panneau
    doc.addEventListener('focusin', function (e) {
      if (!megaIsOpen()) return;
      if (megaRoot.contains(e.target) || mega.contains(e.target)) return;
      closeMega();
    });
    if (scrim) scrim.addEventListener('click', function () { closeMega(); });
    if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', function () { closeMega(); });
  }

  /* ---------- Tiroir mobile ---------- */
  var drawer = $('[data-v23-drawer]');
  var drawerReturn = null;
  var drawerHideTimer = null;
  function drawerIsOpen() { return drawer && drawer.classList.contains('is-open'); }
  function setExpanded(sel, val) {
    $all(sel).forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', val); });
  }
  function openDrawer(trigger) {
    if (!drawer || drawerIsOpen()) return;
    closeSearch();
    closeMega();
    clearTimeout(drawerHideTimer);
    drawerReturn = trigger || doc.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    setExpanded('[data-v23-drawer-open]', 'true');
    lock();
    var closeBtn = $('.v23n-dr__close', drawer);
    setTimeout(function () { if (closeBtn) closeBtn.focus({ preventScroll: true }); }, reduceMotion ? 0 : 60);
  }
  function closeDrawer(noFocus) {
    if (!drawerIsOpen()) return;
    drawer.classList.remove('is-open');
    setExpanded('[data-v23-drawer-open]', 'false');
    unlock();
    drawerHideTimer = setTimeout(function () { drawer.hidden = true; }, reduceMotion ? 0 : 420);
    if (!noFocus && drawerReturn && drawerReturn.focus && doc.body.contains(drawerReturn)) {
      try { drawerReturn.focus({ preventScroll: true }); } catch (err) {}
    }
    drawerReturn = null;
  }
  if (drawer) {
    $all('[data-v23-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (drawerIsOpen()) closeDrawer(); else openDrawer(b); });
    });
    $all('[data-v23-drawer-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () { closeDrawer(); });
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      trapTab(e, $('[data-v23-trap]', drawer));
    });
    // Un lien suivi ferme le tiroir (utile pour les ancres #favoris)
    $all('a[href]', drawer).forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(function () { closeDrawer(true); }, 10); });
    });
    // Passage en largeur ordinateur : on referme proprement
    if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', function (mq) { if (mq.matches) closeDrawer(true); });
  }

  /* Accordéons du tiroir */
  $all('[data-v23-acc]').forEach(function (btn) {
    var panel = doc.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) {
        panel.classList.remove('is-open');
        setTimeout(function () { if (btn.getAttribute('aria-expanded') === 'false') panel.hidden = true; }, reduceMotion ? 0 : 280);
      } else {
        panel.hidden = false;
        void panel.offsetWidth;
        panel.classList.add('is-open');
      }
    });
  });

  /* ---------- Recherche plein écran ---------- */
  var search = $('[data-v23-search]');
  var searchInput = doc.getElementById('search-input');
  var searchReturn = null;
  var searchHideTimer = null;
  function searchIsOpen() { return search && search.classList.contains('is-open'); }
  function openSearch(trigger) {
    if (!search || searchIsOpen()) return;
    closeMega();
    var fromDrawer = drawerIsOpen();
    if (fromDrawer) closeDrawer(true);
    clearTimeout(searchHideTimer);
    searchReturn = fromDrawer ? null : (trigger || doc.activeElement);
    search.hidden = false;
    void search.offsetWidth;
    search.classList.add('is-open');
    setExpanded('[data-v23-search-open]', 'true');
    lock();
    // Focus immédiat (iOS n'ouvre le clavier que dans le geste utilisateur)
    if (searchInput) {
      try { searchInput.focus({ preventScroll: true }); } catch (err) { searchInput.focus(); }
      var v = searchInput.value; searchInput.value = ''; searchInput.value = v;
    }
  }
  function closeSearch() {
    if (!searchIsOpen()) return;
    search.classList.remove('is-open');
    setExpanded('[data-v23-search-open]', 'false');
    unlock();
    var sug = doc.getElementById('search-suggest');
    if (sug) sug.classList.remove('is-on');
    searchHideTimer = setTimeout(function () { search.hidden = true; }, reduceMotion ? 0 : 320);
    if (searchReturn && searchReturn.focus && doc.body.contains(searchReturn)) {
      try { searchReturn.focus({ preventScroll: true }); } catch (err) {}
    }
    searchReturn = null;
  }
  if (search) {
    $all('[data-v23-search-open]').forEach(function (b) {
      b.addEventListener('click', function () { openSearch(b); });
    });
    $all('[data-v23-search-close]', search).forEach(function (b) {
      b.addEventListener('click', closeSearch);
    });
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var sug = doc.getElementById('search-suggest');
        // Premier Échap : wise.js ferme les suggestions ; second : on ferme le panneau
        if (e.target === searchInput && sug && sug.classList.contains('is-on')) return;
        e.preventDefault(); closeSearch(); return;
      }
      trapTab(e, $('[data-v23-trap]', search));
    });
    // Raccourci clavier « / » sur ordinateur
    doc.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      e.preventDefault(); openSearch();
    });
  }

  /* ---------- Échap global ---------- */
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (megaIsOpen()) closeMega(megaRoot && megaRoot.contains(doc.activeElement));
  });

  /* ---------- Onglet actif de la barre du bas ---------- */
  try {
    var path = window.location.pathname;
    if (/\/pages\/compte/.test(path) && /favoris/.test(window.location.hash)) {
      var favTab = $('.v23n-tab a[href*="favoris"]');
      if (favTab) favTab.setAttribute('aria-current', 'page');
    }
  } catch (err) {}
})();
